<template>
<div class="chapter">
<div class="inner_page">
<p class="p_toc_heading" id="tableofcontents">Inhalt</p>
<p class="p_toc_entry_"><a href="#/OPS/section0002#auto_bookmark_toc_1">Zusammenfassung</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0003#auto_bookmark_toc_1">Widmung</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0004#auto_bookmark_toc_1">1</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0005#auto_bookmark_toc_1">2</a></p>
<p class="p_toc_entry_"><span href="#/OPS/section0006#auto_bookmark_toc_1" title="Link target outside of Sample">3</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0007#auto_bookmark_toc_1" title="Link target outside of Sample">4</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0008#auto_bookmark_toc_1" title="Link target outside of Sample">5</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">6</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">7</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">Biogrpahie</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0012#auto_bookmark_toc_1" title="Link target outside of Sample">Von Dirk Greyson</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0013" title="Link target outside of Sample">Besuchen Sie Dreamspinner Press</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0014#auto_bookmark_toc_1" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?c99f9572